import styled from 'styled-components';
import { key } from 'styled-theme';

export const StyledSelect = styled.div`
  position: relative;
  width: ${(props) => props.width || '150px'};
  background: transparent;
  border-radius: ${key('sizes.borderRadius.normal', '18px')};
  padding: 12px 0px;
  background-image: linear-gradient(90deg, #7b61ff, #4facfe);
  background-origin: border-box;
  background-clip: padding-box, border-box;
  color: #fff;
  cursor: pointer;
  user-select: none;
  font-size: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px solid #eceaf8;
  display: flex;
  justify-content: center;
  gap: 10px;
`;

export const StyledSelected = styled.div`
  color: #ffffff;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const StyledOptions = styled.ul`
  position: absolute;
  width: 100%;
  background-image: linear-gradient(90deg, #7b61ff, #4facfe);
  border: 1px solid #eceaf8;
  border-radius: 10px;
  margin-top: 5px;
  list-style: none;
  padding: 0;
  max-height: 150px;
  overflow-y: auto;
  z-index: 999;
  top: 48px;
`;

export const StyledOption = styled.li`
  padding: 12px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;
  color: #ffffff;
  &:hover,
  &.focused {
    background-color: #333;
  }
`;
